module.exports = __webpack_public_path__ + "static/media/1.2626c971.jpg";